import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    createTextVNode as _$ct,
} from 'intact';
import {Dropdown, DropdownMenu, DropdownItem} from 'kpc';
import {Button} from 'kpc';
import {Icon} from 'kpc';

var _$tmp0 = {
    'className': 'ion-ios-arrow-down'
};
var _$tmp1 = {
    'className': 'ion-ios-arrow-down'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Dropdown, {
            'disabled': true,
            'children': [
                _$cc(Button, {
                    'type': 'primary',
                    'children': [
                        _$ct('\n            disabled '),
                        _$cc(Icon, _$tmp0)
                    ]
                }),
                _$cc(DropdownMenu, {
                    'children': [
                        _$cc(DropdownItem, {
                            'children': 'item 1'
                        }),
                        _$cc(DropdownItem, {
                            'children': 'item 2'
                        }),
                        _$cc(DropdownItem, {
                            'children': 'item 3'
                        })
                    ]
                })
            ]
        }),
        _$cc(Dropdown, {
            'children': [
                _$cc(Button, {
                    'type': 'primary',
                    'children': [
                        _$ct('\n            disabled item '),
                        _$cc(Icon, _$tmp1)
                    ]
                }),
                _$cc(DropdownMenu, {
                    'children': [
                        _$cc(DropdownItem, {
                            'children': 'item 1'
                        }),
                        _$cc(DropdownItem, {
                            'disabled': true,
                            'children': 'item 2'
                        }),
                        _$cc(DropdownItem, {
                            'children': 'item 3'
                        })
                    ]
                })
            ]
        })
    ], 4);
};